type ApplePayNetwork = 'amex' | 'discover' | 'jcb' | 'masterCard' | 'visa';

export const makeApplePayRequestBody = (
  subTotal: number,
  supportedNetworks: ApplePayNetwork[] = ['amex', 'discover', 'masterCard', 'visa']   // TODO: use entitlements from response (need mapping)
): ApplePayJS.ApplePayPaymentRequest => {

  const subTotalString = (subTotal/100).toFixed(2);

  return {
    countryCode: 'US',
    currencyCode: 'USD',
    lineItems: [
      {
        label: 'Subtotal',
        amount: subTotalString,
      }
    ],
    total: {
      label: 'Total',
      type: 'final',
      amount: subTotalString,
    },
    supportedNetworks,
    merchantCapabilities: ['supports3DS'],
    requiredShippingContactFields: [
      'email',
    ],
    requiredBillingContactFields: [
      'postalAddress',
      'name',
    ],
  };
};

export type PaymentResponseType = 'PAYMENT_SUCCESS' | 'PAYMENT_FAILURE' | 'SESSION_VALIDATION_ERROR';
